export const AddButtonConstants = {
  ADD_BUTTON_TEXT: 'Add another item',
};

export const RemoveButtonConstants = {
  REMOVE_BUTTON_TEXT: 'Remove item',
  CONFIRMATION_MODAL_TITLE: 'Confirm Action',
  CONFIRMATION_MODAL_TEXT: 'Remove this section?',
  CONFIRMATION_SUBMIT_BUTTON_TEXT: 'Okay',
};

export const MANDATORY_FIELD_IDENTIFIER = '*';
